import React from 'react';
import { Flex, Text, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSlash, faTrash, faPhone, faTrashRestore } from '@fortawesome/free-solid-svg-icons';

const EditBar = ({
    allSelected,
    onSelectAll,
    totalCount,
    selectedCount,
    onBlockClick,
    onTrashClick,
    onDoneClick,
    showIcons
}) => {
    // Default icons if not provided
    const icons = showIcons || ['trash', 'block'];
    //untrash , unblock
    return (
        <Flex alignItems="center" bg="#fafbfc" borderRadius="md" px={4} py={2} mb={4} boxShadow="sm" gap={4}>
            <input
                type="checkbox"
                checked={allSelected}
                onChange={e => onSelectAll(e.target.checked)}
                style={{ marginRight: 8 }}
            />
            <Text fontWeight="medium">Select All ({totalCount})</Text>
            {icons.includes('block') && (
                <IconButton
                    aria-label="Block selected"
                    icon={<FontAwesomeIcon icon={faPhoneSlash} />}
                    colorScheme="red"
                    variant="ghost"
                    size="md"
                    isDisabled={selectedCount === 0}
                    onClick={() => onBlockClick(true)}
                />
            )}
            {icons.includes('unblock') && (
                <IconButton
                    aria-label="Unblock selected"
                    icon={<FontAwesomeIcon icon={faPhone} />}
                    colorScheme="green"
                    variant="ghost"
                    size="md"
                    isDisabled={selectedCount === 0}
                    onClick={() => onBlockClick(false)}
                />
            )}
            {icons.includes('trash') && (
                <IconButton
                    aria-label="Trash selected"
                    icon={<FontAwesomeIcon icon={faTrash} />}
                    colorScheme="red"
                    variant="ghost"
                    size="md"
                    isDisabled={selectedCount === 0}
                    onClick={() => onTrashClick(true)}
                />
            )}
            {icons.includes('untrash') && (
                <IconButton
                    aria-label="Untrash selected"
                    icon={<FontAwesomeIcon icon={faTrashRestore} />}
                    colorScheme="green"
                    variant="ghost"
                    size="md"
                    isDisabled={selectedCount === 0}
                    onClick={() => onTrashClick(false)}
                />
            )}
            <Text
                color="blue.500"
                fontWeight="bold"
                ml="auto"
                cursor="pointer"
                onClick={onDoneClick}
            >
                Done
            </Text>
        </Flex>
    );
};

export default EditBar;
